import { TEMPLATE_ERROR_SHOW, TEMPLATE_ERROR_CLOSE, TEMPLATE_SPINNER_SHOW, TEMPLATE_SPINNER_HIDE, APP_CHECK_ACTIONS, LOAD_APP_CONFIG_SUCCESS, SAVE_USER_PARAMS, SAVE_DIMENSION, SET_NAVIGATE_TO, RESET_NAVIGATE_TO, CLEAR_REDUX_STORE, CART_ITEMS_LIST_NAME, SET_HAND_IT_TO_ME_STATUS, SET_HEADER_TITLE, TAB_REFRESH, } from '../../constants';
export function showError() {
    return {
        type: TEMPLATE_ERROR_SHOW,
    };
}
export function hideError() {
    return {
        type: TEMPLATE_ERROR_CLOSE,
    };
}
export function showSpinner() {
    return {
        type: TEMPLATE_SPINNER_SHOW,
    };
}
export function hideSpinner() {
    return {
        type: TEMPLATE_SPINNER_HIDE,
    };
}
export function checkPermissionsAction(response) {
    switch (response) {
        case 'unavailable':
        case 'blocked':
        case 'denied':
            return {
                type: APP_CHECK_ACTIONS,
                locationEnabled: false,
                locationType: response,
            };
        case 'limited':
        case 'granted':
            return {
                type: APP_CHECK_ACTIONS,
                locationEnabled: true,
                locationType: response,
            };
        default:
            return {
                type: APP_CHECK_ACTIONS,
                locationEnabled: null,
            };
    }
}
export function loadInitialConfigAction(config) {
    return {
        type: LOAD_APP_CONFIG_SUCCESS,
        response: config,
        initial: true,
    };
}
export function setUserParams(params) {
    return {
        type: SAVE_USER_PARAMS,
        response: params,
        saved: true,
    };
}
export function setDimension(params) {
    return {
        type: SAVE_DIMENSION,
        response: params,
    };
}
export function setNavigateToAction(screenName) {
    return {
        type: SET_NAVIGATE_TO,
        screenName,
    };
}
export function setHandItToMeSelected(isHandItToMeSelected) {
    return {
        type: SET_HAND_IT_TO_ME_STATUS,
        isHandItToMeSelected,
    };
}
export function resetNavigateToAction() {
    return {
        type: RESET_NAVIGATE_TO,
    };
}
export function setHeaderTitle(headerTitle) {
    return {
        type: SET_HEADER_TITLE,
        headerTitle,
    };
}
export function clearReduxStore() {
    return {
        type: CLEAR_REDUX_STORE,
    };
}
export function cartItemsListName(listName) {
    return {
        type: CART_ITEMS_LIST_NAME,
        listName,
    };
}
export function tabRefresh(refresh) {
    return {
        type: TAB_REFRESH,
        refresh,
    };
}
